<template>
        <div class="card-wrapper content-block">   
            <div class="first-inner-section ">
                {{cardData.textData}}
                <span class="reviewerName">– {{cardData.reviewerName}}</span>
            </div>                                 
        </div>
</template>
    
<script>
    export default {
        name: "CECourseReviewsDetails", 
        props: {
            cardData: null
        }
    };
    </script>
    
<style lang="scss" scoped>
     @import "@/styles/navigation/navigation-mixins.scss";
             
            .card-wrapper{
                flex: 0 0 auto;
                width: 287px!important;
                height: 308px;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                display: flex;
                flex-direction: column;
                background: #FFFFFF;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 4px;
       
            .first-inner-section{
                position: absolute;
                width: 239px;
                font-family: $font-family-primary;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 26px;
                text-align: center;
                color: #525656;
            }
            .reviewerName
            {
                font-weight: bold;
                color: black;
                display: block;
            }                    
            @media only screen and (min-width: 768px) and (max-width:1180px) {
                width: calc(33.3% - 20px)!important;
                .carousel-control {
                    display: none;
                }
               
                .first-inner-section{
                    width: calc(27.3% - 20px) !important;
                }
            }
            @include wide-mobile {
                .card-wrapper {             
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 24px;
                    gap: 10px;
                    width: 287px!important;
                    height: 308px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                    flex: none;
                    order: 0;
                    flex-grow: 0;
                }
                .first-inner-section
                {
                    position: absolute;
                    width: 239px;
                    font-family: $font-family-primary;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 26px;
                    text-align: center;
                    color: #525656;
                }
            }
        }
    </style>
    